import * as Yup from 'yup';

export default Yup
  .string()
  .trim()
  .matches(/^\d{5}-\d{3}$/, 'CEP inválido')
  .required('Este campo é obrigatório');
